var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.719,
    height: 29.247,
    viewBox: "311.141 831.377 29.719 29.247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m340.007 855.892-4.693-4.693a2.7 2.7 0 0 0-1.36-.73 3.1 3.1 0 0 0-.464-.062 12.155 12.155 0 0 0 2.054-6.053 12.39 12.39 0 0 0 .024-.764c0-6.747-5.467-12.213-12.214-12.213-6.747 0-12.213 5.466-12.213 12.213a12.211 12.211 0 0 0 12.213 12.214 12.104 12.104 0 0 0 5.89-1.525 12.39 12.39 0 0 0 1.313-.84c.057.634.291 1.257.775 1.741l4.694 4.694c.74.669 2.17 1.091 3.441.382a3.16 3.16 0 0 0 .54-.382c1.146-1.004 1.103-2.8.073-3.907a2.88 2.88 0 0 0-.073-.075Zm-25.112-12.302a8.469 8.469 0 0 0 8.46 8.46 8.47 8.47 0 0 0 8.458-8.46c0-4.663-3.796-8.459-8.459-8.459-4.665 0-8.459 3.796-8.459 8.46Z",
    fill: "#357fd8",
    fillRule: "evenodd",
    "data-name": "Path 1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8d3a67c1ab3edb1c441bb9ab00bb3270.svg";
export { ForwardRef as ReactComponent };